<template>
  <!--
    A sortable column header's indicator: neutral when the column is not the active sort,
    a caret in the sort direction when it is.

      <th :aria-sort="col === sort ? (dir === 'asc' ? 'ascending' : 'descending') : 'none'">
        <button @click="sortBy(col)">Name <sort-caret :active="col === sort" :direction="dir" /></button>
      </th>
  -->

  <i
    v-if="active"
    class="sort-caret"
    :class="direction === 'asc' ? 'fas fa-caret-up' : 'fas fa-caret-down'"
  ></i>
  <i v-else class="fas fa-sort sort-caret sort-idle"></i>
</template>

<script>
export default {
  name: "SortCaret",
  props: {
    active: { type: Boolean, default: false },
    direction: { type: String, default: "asc" },
  },
};
</script>

<style scoped>
/*
  Never put Bootstrap's `.small` on a Font Awesome icon: `.small`'s `font-weight: 400` wins over
  `.fas`'s required `900` (source order), and FA Free ships no Regular glyphs for fa-sort/
  fa-caret-* — the icon renders as an empty box. Set size here instead.
*/
.sort-caret {
  /* Fixed width so the label doesn't shift as the glyph swaps. */
  display: inline-block;
  width: 0.7em;
  margin-left: 0.35rem;
  font-size: 0.8rem;
  text-align: center;
  vertical-align: baseline;
}

.sort-idle {
  opacity: 0.35;
}
</style>
